<template>
  <div class="balance-widget">
    <div class="balance-widget__header">
      <div class="balance-widget__icon">
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 7.5C11.982 7.5 15 6.4695 15 4.5C15 2.5305 11.982 1.5 9 1.5C6.018 1.5 3 2.5305 3 4.5C3 6.4695 6.018 7.5 9 7.5Z"
            fill="white"
          />
          <path
            d="M3 7.5C3 9.4695 6.018 10.5 9 10.5C11.982 10.5 15 9.4695 15 7.5V6C15 7.9695 11.982 9 9 9C6.018 9 3 7.9695 3 6V7.5Z"
            fill="white"
          />
          <path
            d="M3 10.5C3 12.4695 6.018 13.5 9 13.5C11.982 13.5 15 12.4695 15 10.5V9C15 10.9695 11.982 12 9 12C6.018 12 3 10.9695 3 9V10.5Z"
            fill="white"
          />
          <path
            d="M3 13.5C3 15.4695 6.018 16.5 9 16.5C11.982 16.5 15 15.4695 15 13.5V12C15 13.9695 11.982 15 9 15C6.018 15 3 13.9695 3 12V13.5Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="balance-widget__title">
        {{ $t('balance_widget.title') }}
      </div>
    </div>

    <div class="balance-widget__balance">
      <div
        class="wallet_popup-block"
        v-if="walletItems.length"
        :class="{ 'wallet_popup-big-block': walletItems.length >= 5 }"
      >
        <div class="item" v-for="wallet in walletItems" :key="wallet.id">
          <div class="wallet_icon">
            <svg
              width="11"
              height="10"
              viewBox="0 0 11 10"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 1.25C0 0.5625 0.55 0 1.22222 0H9.16667C9.32874 0 9.48418 0.065848 9.59879 0.183058C9.71339 0.300268 9.77778 0.45924 9.77778 0.625V1.25H1.22222V1.875H10.3889C10.551 1.875 10.7064 1.94085 10.821 2.05806C10.9356 2.17527 11 2.33424 11 2.5V8.75C11 9.08152 10.8712 9.39946 10.642 9.63388C10.4128 9.8683 10.1019 10 9.77778 10H1.22222C0.898069 10 0.587192 9.8683 0.357981 9.63388C0.128769 9.39946 0 9.08152 0 8.75V1.25ZM8.86111 6.875C9.10423 6.875 9.33738 6.77623 9.50929 6.60041C9.6812 6.4246 9.77778 6.18614 9.77778 5.9375C9.77778 5.68886 9.6812 5.4504 9.50929 5.27459C9.33738 5.09877 9.10423 5 8.86111 5C8.618 5 8.38484 5.09877 8.21293 5.27459C8.04102 5.4504 7.94444 5.68886 7.94444 5.9375C7.94444 6.18614 8.04102 6.4246 8.21293 6.60041C8.38484 6.77623 8.618 6.875 8.86111 6.875Z"
                :fill="wallet.fill"
              />
            </svg>
          </div>
          <div class="wallet_data">
            <div class="data_balance">
              <!--              <span class="balance">{{ formatBalance(wallet.balance) }}</span><span class="currency">{{ getCurrencyValue(wallet.wallet) }}</span>-->
              <span class="balance">{{ formatBalance(wallet.balance) }}</span>
            </div>
            <div class="data_iban">
              <span>{{ wallet.wallet }}</span>
              <svg
                width="5"
                height="8"
                viewBox="0 0 5 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.52433 3.64913L1.0016 0.126462C0.920118 0.0449215 0.811354 0 0.695382 0C0.57941 0 0.470646 0.0449215 0.38917 0.126462L0.129745 0.385823C-0.0390649 0.554826 -0.0390649 0.829503 0.129745 0.998248L3.08787 3.95637L0.126462 6.91778C0.0449859 6.99932 0 7.10802 0 7.22393C0 7.33997 0.0449859 7.44867 0.126462 7.53027L0.385887 7.78957C0.467428 7.87111 0.576128 7.91603 0.6921 7.91603C0.808072 7.91603 0.916836 7.87111 0.998313 7.78957L4.52433 4.26368C4.606 4.18188 4.65086 4.07267 4.6506 3.95657C4.65086 3.84002 4.606 3.73087 4.52433 3.64913Z"
                  fill="#E0E6F2"
                />
              </svg>
            </div>
            <div class="data_name">
              <span>{{ wallet.company_name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="wallet_popup-block" v-else>
        <span>{{ $t('company.empty-balance.title') }}</span>
      </div>
    </div>
    <div class="balance-widget__overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'DashboardBalanceWidget',
  props: {
    company: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      wallets: [],
    }
  },

  computed: {
    ...mapState(['selectedCompanyData']),
    ...mapGetters(['userData']),

    // walletItems() {
    //   return this.selectedCompanyData.wallets.map(wallet => ({
    //     id: Math.floor(Math.random() * 1000),
    //     ...wallet,
    //     fill: this.getRandomFillColor()
    //   }))
    // }

    walletItems() {
      return this.selectedCompanyData.wallets.map((wallet) => ({
        id: crypto.getRandomValues(new Uint32Array(1))[0],
        ...wallet,
        fill: this.getRandomFillColor(),
      }))
    },
  },

  methods: {
    getCurrencyValue(walletString) {
      const currencyMatch = walletString.match(/^[A-Z]{3}/)
      return currencyMatch ? currencyMatch[0] : ''
    },

    formatBalance(balance) {
      return (balance / 100).toLocaleString('ru-RU', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    },

    getRandomFillColor() {
      const predefinedColors = [
        '#ff2d00',
        '#33FF57',
        '#3366FF',
        '#FFFF33',
        '#FF33FF',
        '#33FFFF',
      ]

      const crypto = window.crypto || window.msCrypto
      const array = new Uint32Array(1)
      crypto.getRandomValues(array)

      const randomIndex = array[0] % predefinedColors.length

      return predefinedColors[randomIndex]
    },
  },

  watch: {
    selectedCompanyData: (newValue) => {
      console.log('newValue: ', newValue)

      // selectedCompanyData.wallets
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
::-webkit-scrollbar {
  width: 3px;
}
::-webkit-scrollbar-thumb {
  background: #64748B;
  border-radius: 12px;
}
::-webkit-scrollbar-track {
  background-color: transparent;
}
.balance-widget {
  position: relative;
  z-index: 1;
  background-color: #ffffff;
  box-shadow: 0 20px 30px rgba(225, 235, 253, 0.38);
  border-radius: 20px;
  padding: 22px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom center;
  &__header {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }

  &__icon {
    background: #64748B;
    border-radius: 15px;
    width: 44px;
    height: 44px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 22px;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__title {
    font-weight: 500;
    font-size: pxToRem(16);
    line-height: pxToRem(20);
    text-align: center;
    color: #b9c4d8;
  }

  &__balance {
    font-weight: 600;
    font-size: 40px;
    line-height: 49px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #465a8b;
  }

  //&__overlay {
  //  position: absolute;
  //  width: 100%;
  //  height: 100%;
  //  bottom: 0;
  //  left: 0;
  //
  //  img, svg {
  //    width: 100%;
  //    height: 100%;
  //    object-fit: cover;
  //    object-position: center bottom;
  //  }
  //}

  .wallet_popup-block {
    width: 100%;
    span {
      font-size: 12px;
      font-weight: 700;
      line-height: 12px;
      color: #666d79;
    }
    .item {
      cursor: pointer;
      display: flex;
      gap: 10px;
      border-bottom: 1px solid #909cb01c;
      padding: 10px 20px;
      .wallet_data {
        display: flex;
        flex-direction: column;
        gap: 6px;
        width: 100%;
        .data_name {
          display: flex;
          span {
            font-size: 10px;
            font-weight: 400;
            line-height: 15px;
            color: #b9c4d8;
          }
        }

        .data_iban {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
          span {
            font-weight: 600;
            font-size: 10px;
            line-height: 11px;
            color: #585f6d;
          }
        }

        .data_balance {
          display: flex;
          align-items: center;
          gap: 5px;
          span {
            font-size: 14px;
            font-weight: 600;
            line-height: 12px;
            color: #64748B;
          }

          //.currency {
          //  font-weight: 400;
          //}
        }
      }

      .wallet_icon {
        display: flex;
      }

      &.active {
        background-color: #909cb01c;
      }

      &:hover {
        background-color: #909cb01c;
      }

      &:last-child {
        border: none;
      }
    }

    &.wallet_popup-big-block {
      max-height: 210px;
      overflow-y: auto;
      background-color: #fff;
    }
  }
}
</style>
